<template>
  <el-form @submit.native.prevent label-width="130px" label-position="left">
    <!-- 修改密码 -->
    <zt-dialog
      class="dialog-modify-phone"
      v-bind="$attrs"
      v-on="$listeners"
      :append-to-body="true"
      :modal-append-to-body="false"
    >
      <el-form-item class="mt16" label="旧密码：" :error="err.password">
        <el-input type="password" placeholder="请输入旧密码" v-model.trim="param.password" />
      </el-form-item>

      <el-form-item class="mt16" label="新密码：" :error="err.password1">
        <el-input type="password" placeholder="请输入新密码" v-model.trim="param.password1" />
      </el-form-item>

      <el-form-item class="mt16" label="再次输入新密码：" :error="err.password2">
        <el-input type="password" placeholder="请输入再次输入新密码" v-model.trim="param.password2" />
      </el-form-item>

      <zt-button type="primary" @click="onSubmit" @keyup.enter="onSubmit" native-type="submit">修改</zt-button>
    </zt-dialog>
  </el-form>
</template>

<script>
import ZtDialog from '@cps/ZtDialog';
import { taoke_mypassword_change } from '@/api/myCenter';
import { sleep } from '@/utils/timer';

export default {
  components: {
    ZtDialog,
  },
  props: {
    submit: Function,
  },
  computed: {},
  data: () => ({
    param: {
      password: '', // 旧密码
      password1: '', // 新密码
      password2: '', // 再次输入密码
    },

    err: {
      password: '',
      password1: '',
      password2: '',
    },
  }),
  methods: {
    //
    onSubmit() {
      taoke_mypassword_change({
        ...this.param,
      }).then(({ data }) => {
        let { error_code, error_message } = data;
        if (error_code == 0) {
          this.$message.success('密码修改成功');
          sleep(() => {
            this.$store.dispatch('LogOut').then(() => {
              this.$router.push({
                path: '/',
              });
            });
          }, 1000);
        } else {
          for (let key in this.err) {
            this.err[key] = '';
          }
          switch (error_code) {
          case 4:
            this.err.password = error_message;
            break;
          case 5:
            this.err.password1 = error_message;
            break;
          case 6:
            this.err.password2 = '两次输入的密码不一致';
            break;
          default:
            this.$message.error(error_message);
            break;
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/form.scss";
.dialog-modify-phone /deep/ {
  .el-dialog__body {
    text-align: center;
  }
}

.el-form-item {
  margin: 0 auto 22px auto;
  width: 380px;
}

.link {
  color: $theme;
}
</style>